import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono-eyebrow uppercase tracking-[0.2em] text-xs">Loading…</div>
  );
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname + loc.search }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
